import BaseModel from "./base/baseModel";

export default class ProdutoMarkupDinamicoModel extends BaseModel {
    id?: number = null;
    produtoId: number = null;
    quantidadeLimite: number = null;
    markup: number = null;
    demaisValores = false;
}
